import React from "react";
import ReactHtmlParser from "react-html-parser";
import ButtonComp from "./ButtonComp";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
// ================= ATOMS =================
const StatsItem = ({ value, highlight, label, index, icon, extraClass2="",cardValue="",subText="",link,btnText="",subGrayText="",grayLabel="",imgWidth="79px",imgHeight="80px",center=false }) => (
    
  <div className="text-center stats-item-responsive noc-hero-banner course-card" key={index}>
      <div className={`hero-title noc-data h-100 ${center ? "align-items-center justify-content-center" : ""} `}>
      <div className={`d-flex flex-column gap-2 gap-lg-4 ${center ? "align-items-center justify-content-center" : ""}`}>
          {icon && <img src={icon} alt="" style={{width:imgWidth,height:imgHeight}}/>}
       <div className={`bottom-stats-text ${extraClass2}`}>
        {value && (
        <span className="FS24FW500 fw-600 hero-title">{value}</span>
        )}
        {highlight && (
         <span className="noc-text-success FS18FW400 fw-700">{highlight}</span>
          )}
          {label && (
               <div className="FS16FW500 fw-600 text-gray-pricing plus-sans">{label}</div>
          )}
         {grayLabel && (
          <p className="FS16FW500 fw-700 plus-sans mb-0 mb-lg-3">{grayLabel}</p>
         )}
          {cardValue && (
            <span className="FS20FW500 fw-700 plus-sans">{cardValue}</span>
          )}
          {subText && (
              <p className="FS12 fw-400 light-gray mb-0">{ReactHtmlParser(subText)}</p>
            )}
          {subGrayText && (
            <p className="FS20FW500 plus-sans text-gray-pricing mb-0">{subGrayText}</p>
          )}
       </div>
      </div>
        {
      link && btnText && (
         typeof link === "function" ? (
      <button
        type="button"
        onClick={link}
        className="greenText FS16FW500 fw-700 plus-sans m-0"
        style={{ background: "none", border: "none", padding: 0, textAlign: "left", alignSelf: "flex-start", textDecoration: "underline" }}
      >
        {btnText}{"  "}
        <FaArrowRight />
      </button>
    ) : (
      <Link to={link} className="greenText FS16FW500 fw-700 plus-sans m-0">{btnText}{"  "}<FaArrowRight /></Link>
    )
      )
    }
      </div>
   
  </div>
);

const StatsItemText = ({ value, highlight, label, index }) => (
  <div className="text-center px-1 px-sm-2 px-md-3 stats-item-responsive">
    {([1, 0].includes(index) || highlight === "+" || highlight === "%") ? (
      <div className="hero-title fw-800 FS48">
        {value}
        <span className="symbol-text-success">{highlight}</span>
      </div>
    ) : (
      <div className="hero-title fw-800 FS48">
        <span className="symbol-text-success">{highlight}</span>
        {value}
      </div>
    )}
    <div className="FS20FW500 text-gray-pricing plus-sans mt-1">{label}</div>
  </div>
);

// ================= ORGANISM =================
const NocBanner = ({ data ,extraClass="",extraClass2="",top=""}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // First preference → custom action (popup, modal etc.)
    if (data.btn_outline.onClick) {
      data.btn_outline.onClick();
      return;
    }

    // Route navigation
    if (data.btn_outline.link) {
      navigate(data.btn_outline.link);
    }
  };
  
  return (
    <section className={`new-updated-hero-section position-relative noc-branches-banner ${extraClass}`}>
      <div className="hero-section text-white position-relative overflow-hidden">
        <div className="hero-bg" />

        {/* <div className="custom-container position-relative z-2 py-3 py-sm-4 py-md-5 mt-5 px-0"> */}
         <div className="custom-container position-relative z-2 py-3 mt-5 px-0">
            {/* LEFT */}
            <div className="d-flex flex-column align-items-center justify-content-center mb-4 mb-lg-0">
              <span className="students-stat mb-2 mb-sm-3 d-inline-block text-center">{data?.badge}</span>

              {data?.title && data.title()}

              <p
                className="mb-5 FS20FW500 fw-400 text-center w-75"
                style={{ color: "rgba(222, 222, 222, 1)" }}
              >
                {data?.subtitle && ReactHtmlParser(data?.subtitle)}
              </p>
              <div className="d-flex flex-column flex-xl-row gap-2 gap-sm-3 mb-5">
                { data?.btnText &&  (
                  <ButtonComp
                  btnText={data?.btnText}
                  link={data?.btnLink || "mailto:info@languageacademy.com.au"}
                  className="btn-green"
                />
                  )}
                {data.btn_outline && (
                  <button
                    className="border-btn gap-2 primary-btn w-auto w-sm-auto"
                    onClick={handleClick}
                  >
                    {data.btn_outline.text}
                    <img
                      src={`/images/web-new-images/new-green-arrow.png`}
                      alt="Register Now"
                    />
                  </button>
                )}
              </div>
            </div>
        </div>
      </div>
      {/* STATS BAR */}
      { data?.bottomStats && (
        <div className={`stats-bar mt-3 mt-sm-4 mt-md-5 mb-0 p-3 p-sm-3 p-md-4 d-flex flex-column flex-lg-row flex-wrap justify-content-between gap-3 custom-container`} style={{top:top}}>
          {data?.bottomStats.map((item, i) => (
            <StatsItem key={i} index={i} {...item} extraClass2={extraClass2}/>
          ))}
        </div>
      ) }
      { data?.bottomStatsText && (
        <div className={`stats-bar stats-text-content mt-3 mt-sm-4 mt-md-5 mb-0 p-3 p-sm-3 p-md-4 d-flex flex-column flex-lg-row flex-wrap justify-content-between gap-3 custom-container`} style={{top:top}}>
          {data?.bottomStatsText.map((item, i) => (
            <StatsItemText key={i} index={i} {...item} />
          ))}
        </div>
      ) }
    </section>
  );
};

export default NocBanner;
